import {FC} from 'react';
import {Box} from '@mui/material';
import {StyledFooterGroupHeading} from '@/components/footer/FooterGroup.styles';
import {FooterInternalLink} from '@/components/footer/FooterInternalLink';
import {FooterEmailLink} from '@/components/footer/FooterEmailLink';
import {FooterExternalLink} from '@/components/footer/FooterExternalLink';
import {FooterGroupFieldsFragment, FooterLinkFieldsFragment} from '@generated/graphql';
import {hasLinkAndLabel} from '@/lib/type-guards';

type FooterGroupProps = {
    group: FooterGroupFieldsFragment
    withLabel?: boolean;
}

export type FooterLinkWithLinkAndLabel = FooterLinkFieldsFragment & {
    link: string;
    label: string
}

export const FooterGroup: FC<FooterGroupProps> = ({group, withLabel}) => {
  const label = group.label;
  const links = (group.footerLinksCollection?.items ?? []).filter(hasLinkAndLabel);

  return (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: 0.10}}>
      {withLabel && <StyledFooterGroupHeading>{label}</StyledFooterGroupHeading>}
      {links.map((l) => {
        if(l.isEmailLink) {
          return <FooterEmailLink link={l} key={l.label} />
        }
        if(l.isExternalLink) {
          return <FooterExternalLink link={l} key={l.label} />
        }
        return <FooterInternalLink link={l} key={l.label} />
      })}
    </Box>
  )
}